var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column-grid"},[_c('icon-item',{attrs:{"icon":_vm.item.meta.icon || (_vm.item.meta && _vm.item.meta.icon),"title":_vm.item.meta.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }